import React from 'react';

interface SEOHelmetProps {
  title?: string;
  description?: string;
  canonicalUrl?: string;
  imageUrl?: string;
}

export function SEOHelmet({
  title = "DealerDial.ai - AI Voice Agents for Auto Dealerships",
  description = "Deploy intelligent AI voice agents that sound human to reconnect with your previous customers, drive repeat business, and boost service revenue - all automatically.",
  canonicalUrl = "https://dealerdial.ai",
  imageUrl = "https://dealerdial.ai/og-image.jpg"
}: SEOHelmetProps) {
  React.useEffect(() => {
    // Update meta tags dynamically
    document.title = title;
    
    const metaTags = {
      'description': description,
      'og:title': title,
      'og:description': description,
      'og:image': imageUrl,
      'og:url': canonicalUrl,
      'twitter:title': title,
      'twitter:description': description,
      'twitter:image': imageUrl,
      'twitter:url': canonicalUrl,
    };

    Object.entries(metaTags).forEach(([name, content]) => {
      // Update existing meta tags or create new ones
      let meta = document.querySelector(`meta[property="${name}"]`) ||
                 document.querySelector(`meta[name="${name}"]`);
      
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(name.includes('og:') || name.includes('twitter:') ? 'property' : 'name', name);
        document.head.appendChild(meta);
      }
      
      meta.setAttribute('content', content);
    });

    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalUrl);
  }, [title, description, canonicalUrl, imageUrl]);

  return null;
}